<template>
  <fragment>
    <AppBody
      title="Produtores / Segmentos"
      subtitle="Segmento"
      :actions="actions"
    >
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form
            @submit.prevent="$loja_segmentos.filtroSegmentos()"
            class="search-forms"
          >
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  label="Descrição"
                  placeholder="Insira a descrição"
                  data-cy="descricao"
                  v-model="$loja_segmentos.filter.descricao"
                ></BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :items="status"
                  item-text="text"
                  item-value="value"
                  data-cy="status"
                  label="Status"
                  placeholder="Selecione o status"
                  clearable
                  v-model="$loja_segmentos.filter.ativo"
                  @click:clear="$loja_segmentos.filter.ativo = ''"
                ></BaseSelect>
              </v-col>
              <v-col class="d-flex justify-end">
                <BaseButton variant="filter" data-cy="filtrar" type="submit">
                  Filtrar
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="table-body"
          :headers="headers"
          item-key="idsegmento"
          loading-text="Buscando informações..."
          :loading="$loja_segmentos.loading_segmentos"
          no-data-text="Não há registro de segmentos"
          :items="orderedSegmentos"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: 'Segmentos por Página:',
          }"
        >
          <template v-slot:item.ins_dthr="{ item }">
            {{ item.ins_dthr | dthr_pt_br }}
          </template>
          <template v-slot:item.ativo="{ item }">
            {{ item.ativo ? "ATIVO" : "INATIVO" }}
          </template>
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    icon
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="openModal('modal-body-segmento-add', 'edit', item)"
                    class="mr-2"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <BaseButton
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    dark
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      $loja_segmentos.remover(
                        item.idsegmento,
                        'Deseja realmente excluir este segmento?'
                      )
                    "
                    class="lojas-segmento-button1"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </BaseButton>
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </CardModule>
    </AppBody>
    <ModalAddSegmento />
    <ModalConfirmacao
      :textModal="$loja_segmentos.text"
      @callback="$loja_segmentos.funcaoRemover"
    />
  </fragment>
</template>

<script>
import _ from "lodash";
export default {
  name: "Segments",
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    ModalAddSegmento: () =>
      import("@/components/lojas/lojas-modal-segmento-add.vue"),
    ExpansionPanelFilters: () =>
      import("@/components/forms/ExpansionPanelFilters.vue"),
  },
  metaInfo: {
    title: "Segmentos | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Segmentos | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      actions: [
        {
          name: "Novo segmento",
          action: () => this.openModal("modal-body-segmento-add", "new", ""),
        },
      ],
      headers: [
        {
          text: "Descrição",
          align: "center",
          sortable: true,
          value: "descricao",
        },
        {
          text: "Data Cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "ativo",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          fixed: false,
          value: "actions",
        },
      ],
      status: [
        {
          text: "ATIVO",
          value: 1,
        },
        {
          text: "INATIVO",
          value: 0,
        },
      ],
    };
  },
  computed: {
    orderedSegmentos() {
      return _.orderBy(
        this.$loja_segmentos.segmentos,
        ["ativo", "ins_dthr"],
        ["desc", "desc"]
      );
    },
  },
  methods: {
    openModal(name, type, data) {
      this.$loja_segmentos.segmentoAddOrEdit = type;
      (this.$loja_segmentos.cadastro.idsegmento = data.idsegmento),
        (this.$loja_segmentos.cadastro.descricao = data.descricao),
        (this.$loja_segmentos.cadastro.ativo = data.ativo),
        (document.getElementsByClassName(name)[0].style.display = "flex");
    },
  },
  mounted() {
    this.$loja_segmentos.getSegmentos();
  },
  destroyed() {
    this.$loja_segmentos.limpaFormularioDeSegmentos();
    this.$loja_segmentos.limpaFiltros();
  },
};
</script>

<style scoped>
.lojas-segmento-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: transparent;
}

.lojas-segmento-icon {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
</style>
